var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOneBanknoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.099 16.416a4.693 4.693 0 01-4.688 4.688 4.693 4.693 0 01-4.687-4.688 4.693 4.693 0 014.687-4.687 4.693 4.693 0 014.688 4.687zm-1.875 0a2.816 2.816 0 00-2.813-2.812 2.816 2.816 0 00-2.812 2.812 2.816 2.816 0 002.812 2.813 2.816 2.816 0 002.813-2.813z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.911 17.354a.937.937 0 100-1.875.937.937 0 000 1.875zM9.849 16.416a.937.937 0 11-1.875 0 .937.937 0 011.875 0z",
    fill: "#ADC6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.024 8a.938.938 0 00-.738.916v15c0 .518.42.938.938.938h26.312c.518 0 .938-.42.938-.938v-15A.938.938 0 0029.735 8H3.025zm23.86 1.854c.284.798.917 1.43 1.715 1.714V9.854h-1.714zm1.715 3.655a4.702 4.702 0 01-3.656-3.655H7.817a4.701 4.701 0 01-3.656 3.655v5.814a4.702 4.702 0 013.656 3.656h17.126a4.702 4.702 0 013.656-3.656V13.51zM4.16 11.568a2.826 2.826 0 001.714-1.714H4.16v1.714zm1.714 11.41a2.826 2.826 0 00-1.714-1.713v1.714h1.714zm22.724-1.713a2.826 2.826 0 00-1.714 1.714h1.714v-1.714z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/one-banknote-icon.62220b3cdafe06fde7fbb5708f437fc2.svg";
export { SvgOneBanknoteIcon as ReactComponent };